class InternetConnectionManager {
    constructor() {
        this.alertElement = null;
        this.isOffline = false;
        this.direction = document.documentElement.dir || "rtl";
        this.language = document.documentElement.lang || "ar";
        this.init();
    }

    init() {
        this.createAlertElement();
        this.setupEventListeners();
    }

    createAlertElement() {
        this.alertElement = document.createElement("div");
        this.alertElement.id = "internet-status-alert";
        this.alertElement.style.cssText = `
             position: fixed;
             bottom: 0;
             left: 0;
             width: 100%;
             padding: 10px;
             z-index: 9999;
             text-align: center;
             display: none;
             opacity: 0;
             transition: all 0.3s ease;
             background-color: #FF4B4B;
             color: white;
         `;
        document.body.appendChild(this.alertElement);
    }

    getMessage(type) {
        const messages = {
            ar: {
                offline: "انقطع الاتصال بالإنترنت",
                online: "تم استعادة الاتصال بالإنترنت",
            },
            en: {
                offline: "Internet connection lost",
                online: "Internet connection restored",
            },
        };

        return this.language === "ar" ? messages.ar[type] : messages.en[type];
    }

    showAlert(type = "offline") {
        if (type === "offline") {
            this.alertElement.style.backgroundColor = "#FF4B4B";
            this.alertElement.textContent = this.getMessage("offline");
        } else {
            this.alertElement.style.backgroundColor = "#2ecc71";
            this.alertElement.textContent = this.getMessage("online");
        }

        this.alertElement.style.display = "block";
        setTimeout(() => {
            this.alertElement.style.opacity = "1";
        }, 50);

        if (type === "online") {
            setTimeout(() => {
                this.hideAlert();
            }, 3000);
        }
    }

    hideAlert() {
        this.alertElement.style.opacity = "0";
        setTimeout(() => {
            this.alertElement.style.display = "none";
        }, 300);
    }

    setupEventListeners() {
        window.addEventListener("online", () => {
            if (this.isOffline) {
                this.isOffline = false;
                this.showAlert("online");
            }
        });

        window.addEventListener("offline", () => {
            if (!this.isOffline) {
                this.isOffline = true;
                this.showAlert("offline");
            }
        });
    }
}

export default new InternetConnectionManager();
